import React, { useEffect } from "react";

const subscribers = [];
let globalCurrentGames = [];

export function useCurrentGamesList() {
    const [currentGames, setCurrentGames] = React.useState(globalCurrentGames);
    useEffect(() => {
        const sub = () => setCurrentGames(globalCurrentGames);
        subscribers.push(sub);
        return () => {
            subscribers.splice(subscribers.indexOf(sub), 1);
        };
    }, [currentGames]);
    return currentGames;
}

export function useCurrentGameId() {
    const currentGames = useCurrentGamesList();
    if (currentGames.length === 0) {
        return null;
    } else {
        return currentGames[currentGames.length - 1].id;
    }
}

export function useSetCurrentGameId(id) {
    useEffect(() => {
        if (!id) {
            return () => {/* NOOP */};
        }

        const handle = { id };
        globalCurrentGames = [...globalCurrentGames, handle];
        subscribers.forEach(sub => sub());
        return () => {
            const idx = globalCurrentGames.indexOf(handle);
            if (idx >= 0) {
                globalCurrentGames = globalCurrentGames.slice(0, idx).concat(globalCurrentGames.slice(idx + 1));
                subscribers.forEach(sub => sub());
            }
        };
    }, [id]);
}
